import { useRef, useState, useEffect } from "react";
import Cropper from "cropperjs";


export default function ImageCropTool() {
  const fileInputRef = useRef(null);
  const imageRef = useRef(null);
  const cropperRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (imageSrc && imageRef.current) {
      cropperRef.current = new Cropper(imageRef.current, {
        viewMode: 1,
        dragMode: "crop",
        autoCropArea: 1,
        restore: false,
        guides: true,
        center: true,
        highlight: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
      });
    }
  }, [imageSrc]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setImageSrc(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const cropImage = () => {
    if (cropperRef.current) {
      const canvas = cropperRef.current.getCroppedCanvas();
      if (canvas) {
        const croppedImageURL = canvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.href = croppedImageURL;
        downloadLink.download = "cropped-image.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 p-6">
      <section className="mt-8 bg-gray-800 text-white p-6 rounded-xl shadow-lg">
  <h2 className="text-2xl font-bold mb-4">📸 How to Use the Image Crop Tool</h2>
  <p className="mb-4">
    The <strong>Image Crop Tool</strong> allows you to quickly crop any image directly in your browser — no uploads, no privacy concerns. Whether you're editing a photo for a profile picture, social media, or a document, this tool helps you do it fast and accurately.
  </p>
  <ul className="list-disc list-inside space-y-2">
    <li>Upload an image from your device using the file picker.</li>
    <li>Use your mouse to drag and resize the cropping area.</li>
    <li>Once satisfied, click <strong>“Crop & Download”</strong> to save the cropped image as PNG.</li>
  </ul>
  <p className="mt-4">
    This tool works entirely offline in your browser using modern JavaScript and the <code>Cropper.js</code> library. Your images are never uploaded or stored.
  </p>
  <p className="mt-2">
    Ideal for developers, designers, content creators, and anyone needing quick image adjustments without opening complex software like Photoshop.
  </p>
</section>
      <div className="bg-gray-800 shadow-xl rounded-2xl p-6 w-full max-w-6xl text-white">
        <h2 className="text-2xl font-bold text-center mb-4">Image Crop Tool</h2>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="block w-full text-sm text-white border border-gray-600 rounded-lg cursor-pointer bg-gray-700 focus:outline-none p-2"
        />
        <div className="relative mt-4 w-full h-[800px] bg-gray-700 rounded-lg overflow-hidden flex justify-center items-center">
          {imageSrc && (
            <img
              ref={imageRef}
              src={imageSrc}
              alt="Crop"
              className="max-w-full max-h-full object-contain"
            />
          )}
        </div>
        <button
          onClick={cropImage}
          className="w-full mt-4 bg-cyan-500 hover:bg-cyan-600 transition text-lg py-2 rounded-lg"
        >
          Crop & Download
        </button>
      </div>
    </div>
  );
}
